var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.96 8C25.88 8 8 25.92 8 48C8 70.08 25.88 88 47.96 88C70.08 88 88 70.08 88 48C88 25.92 70.08 8 47.96 8ZM75.68 32H63.88C62.6 27 60.76 22.2 58.36 17.76C65.72 20.28 71.84 25.4 75.68 32ZM48 16.16C51.32 20.96 53.92 26.28 55.64 32H40.36C42.08 26.28 44.68 20.96 48 16.16ZM17.04 56C16.4 53.44 16 50.76 16 48C16 45.24 16.4 42.56 17.04 40H30.56C30.24 42.64 30 45.28 30 48C30 50.72 30.24 53.36 30.56 56H17.04ZM20.32 64H32.12C33.4 69 35.24 73.8 37.64 78.24C30.28 75.72 24.16 70.64 20.32 64ZM32.12 32H20.32C24.16 25.36 30.28 20.28 37.64 17.76C35.24 22.2 33.4 27 32.12 32ZM48 79.84C44.68 75.04 42.08 69.72 40.36 64H55.64C53.92 69.72 51.32 75.04 48 79.84ZM57.36 56H38.64C38.28 53.36 38 50.72 38 48C38 45.28 38.28 42.6 38.64 40H57.36C57.72 42.6 58 45.28 58 48C58 50.72 57.72 53.36 57.36 56ZM58.36 78.24C60.76 73.8 62.6 69 63.88 64H75.68C71.84 70.6 65.72 75.72 58.36 78.24ZM65.44 56C65.76 53.36 66 50.72 66 48C66 45.28 65.76 42.64 65.44 40H78.96C79.6 42.56 80 45.24 80 48C80 50.76 79.6 53.44 78.96 56H65.44Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/globalIcon.f92564e2e4a31bbbe64456d9c2ad9104.svg";
export { ForwardRef as ReactComponent };